import script from "./AccountPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountPage.vue?vue&type=script&setup=true&lang=ts"

import "./AccountPage.vue?vue&type=style&index=0&id=f7f4aea2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7f4aea2"]])

export default __exports__